import type { User } from "../../types";

type Plan = User["plan"];

export const PROJECT_LIMIT: Record<Plan, string> = {
  free: "Unlimited (alpha)",
  pro: "Unlimited",
  agency: "Unlimited",
};
